export enum FormOperationMode {
  OperationModeAdd = 'add',
  OperationModeEdit = 'edit'
}
